import Vue from "vue";
import CompanyService from "@/service/CompanyService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StaffService from "@/service/StaffService";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import StoreGetter from "@/constants/StoreGetter";
import { PayMethod } from "@/model/PayMethod";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Setting from "@/constants/Settings";
import PayMethodService from "@/service/PayMethodService";
import payMethodValidation from "./S082200-PayMethodValidation.js";
import Paginate from "vuejs-paginate";
import BankService from "../../../service/BankService.js";
import moment from "moment";
var payMethodObj = new payMethodValidation();
export default {
    name: "payMethod",
    mounted() {
        payMethodObj.payMethodValidation();
        this.assignRights();
        this.getBankList();
        this.getAllPayMethod()
    },
    components: {
        paginate: Paginate,
    },
    data: () => ({
        menuRights: { allRights: {}, rightsForThisMenu: {} },
        menuId: Setting.MenuID.S_PayMethod,
        dictEnum: dictEnum,
        payMethod: new PayMethod(),
        isEditMode: false,
        payMethodList: [],
        bankList: [],
        selectedPayMethodModel: new PayMethod(),
        selectAllPayMethod: false,
        currentPage: 1,
        perPage: 15,
        fields: [
            {
                key: "Method",
                label: t.t(dictEnum.LBL_PayMethod)
            },
            {
                key: "Autopay",
                label: t.t(dictEnum.LBL_ExpAutopayFile)
            },
            {
                key: "BankCode",
                label: t.t(dictEnum.LBL_BankCode)
            },
            {
                key: "BankAcNum",
                label: t.t(dictEnum.LBL_AC)
            },
            {
                key: "BankFileType",
                label: t.t(dictEnum.LBL_BankFileType)
            },
            {
                key: "Action",
                label: ""
            },
        ],
    }),
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
    },
    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },

        async getBankList() {
            var self = this;
            var obj = {}
            const response = await BankService.getAllBanks(obj);
            if (response.data.IsSuccess) {
                self.bankList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getAllPayMethod() {
            var self = this;
            var obj = {}
            const response = await PayMethodService.getAllPayMethod(obj);
            if (response.data.IsSuccess) {
                self.payMethodList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        selectAllPayMethodRecord: function () {
            var self = this;
            var IsSelected = self.selectAllPayMethod;
            self.payMethodList.forEach(function (val, index) {
                val["isSelected"] = IsSelected;
            });
        },
        deleteMultiplePayMethodPopup: function () {
            var arrayList = [];
            var self = this;
            if (self.selectedPayMethodModel) {
                $('#deletePayMethodListModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
            }
        },
        async deleteMultiplePayMethod() {
            var arrayList = [];
            var self = this;
            $('#deletePayMethodListModel').modal('hide');
            const obj = {
                model: {
                    Grp: self.selectedPayMethodModel.Grp,
                    GrpDesc: self.selectedPayMethodModel.GrpDesc,
                    PayTypeCode: self.selectedPayMethodModel.PayTypeCode,
                    PayMethodCode: self.selectedPayMethodModel.PayMethodCode,
                    StartDay: self.selectedPayMethodModel.StartDay,
                    ValueDay: self.selectedPayMethodModel.ValueDay,
                }
            };
            const response = await PayMethodService.deletePayMethod(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetPayMethod();
                await self.getAllPayMethod();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (this.selectedPayMethodModel.Method == item.Method) {
                return 'selected-tr'
            }
        },
        OnPayMethodSelect: function (model) {
            this.selectedPayMethodModel = model;
        },
        addPayMethod: function () {
            var self = this;
            $('#payMethodModel').modal('show');
            self.isEditMode = false;
            self.payMethod = new PayMethod();
            self.$validator.reset();
            self.vErrors.clear();
        },
        async savePayMethodDetail(obj) {
            var self = this;
            const response = await PayMethodService.addPayMethod(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetPayMethod();
                await self.getAllPayMethod();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async editPayMethod(obj) {
            var self = this;
            const response = await PayMethodService.updatePayMethod(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetPayMethod();
                await self.getAllPayMethod();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async savePayMethod() {
            var self = this;
            self.$validator.validateAll().then(result => {
                if (result) {
                    $('#payMethodModel').modal('hide');
                    const obj = {
                        model: {
                            Method: self.payMethod.Method,
                            Autopay: self.payMethod.Autopay,
                            BankCode: self.payMethod.BankCode,
                            BankAcNum: self.payMethod.BankAcNum,
                            BankFileType: self.payMethod.BankFileType,
                            DateAdd: self.payMethod.DateAdd,
                            AddBy: self.payMethod.AddBy,
                            DateModify: moment().format(Setting.DateTime.yyyymmdd),
                            ModifyBy: self.user.UserID,
                            RecDel: false
                        }
                    };
                    if (self.isEditMode) {
                        self.editPayMethod(obj);
                    }
                    else {
                        self.savePayMethodDetail(obj);
                    }
                }
            });
        },
        async editPayMethodDetail() {
            var self = this;
            self.isEditMode = true;
            if (self.selectedPayMethodModel.EDesc != "") {
                self.payMethod = this.selectedPayMethodModel;
                self.$validator.reset();
                self.vErrors.clear();
                $('#payMethodModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
            }
        },
        resetPayMethod: function () {
            var self = this;
            self.selectAllPayMethod = false;
            self.isEditMode = false;
            self.payMethod = new PayMethod();
            self.selectedPayMethodModel = new PayMethod();
            self.$validator.reset();
            self.vErrors.clear();
        },
        closePayMethodPopup: function () {
            var self = this;
            self.selectAllPayMethod = false;
            self.isEditMode = false;
            self.payMethod = new PayMethod();
            self.selectedPayMethodModel = new PayMethod();
            self.$validator.reset();
            self.vErrors.clear();
            $('#payMethodModel').modal('hide');
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S082200-PayMethod/S082200-PayMethod.js